import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { reducer as simpleFormReducer, INITIAL_SIMPLEFORM_STATE } from 'app/infrastructure/simple-form/reducers';
import { AdministrationRoleEditState } from './types-store';
import {
  ACTION, RequestLoadRole, ReceiveLoadRole, FailLoadRole,
  RequestLoadRoleAccess, ReceiveLoadRoleAccess, FailLoadRoleAccess,
  RequestExtraInfo, ReceiveExtraInfo, FailExtraInfo,
  RequestPersonOptions, ReceivePersonOptions, FailPersonOptions,
  RequestAddRole, ReceiveAddRole, FailRoleExecute, ProcessRoleFailed,
  RequestUpdateRole, ReceiveUpdateRole, RequestRoleDelete,
  ClearRoleData, UpdateAccessData, ClearValidation,
  RequestDefaultRole, ReceiveDefaultRole, FailDefaultRole,
  RequestSetDefaultRole, ReceiveSetDefaultRole, FailSetDefaultRole, ChangeDefaultRoleMark
} from './action-types'; import { withOptionsReducer } from 'app/components/options-handler';
import { AccessItem } from 'app/components/access-panel/shared/types';
import { clearValidation } from 'app/components/access-panel/validation/validation-messages';

export const INITIAL_ADMINISTRATION_ROLE_EDIT_STATE: AdministrationRoleEditState = {
  fetchingLoadRole: false,
  fetchingSaveRole: false,
  fetchingDefaultRole: false,
  isSettingDefaultRole: false,
  accessPerson: undefined,
  data: undefined,
  accessData: {},
  validation: {},
  extraInfoCodes: {
    fetching: false,
    values: []
  },
  personOptionsCodes: {
    fetching: false,
    values: []
  },
  currentDefaultRole: undefined,
  markedAsDefaultRole: false,
  ...INITIAL_SIMPLEFORM_STATE
};

export const reducers: { [indexer: string]: Reducer<AdministrationRoleEditState> } = {
  [ACTION.REQUEST_ADD_ROLE]: (state: AdministrationRoleEditState, action: RequestAddRole): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingSaveRole: true
    };
  },
  [ACTION.REQUEST_UPDATE_ROLE]: (state: AdministrationRoleEditState, action: RequestUpdateRole): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingSaveRole: true
    };
  },
  [ACTION.RECEIVE_ADD_ROLE]: (state: AdministrationRoleEditState, action: ReceiveAddRole): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingSaveRole: false
    };
  },
  [ACTION.RECEIVE_UPDATE_ROLE]: (state: AdministrationRoleEditState, action: ReceiveUpdateRole): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingSaveRole: false
    };
  },
  [ACTION.FAIL_ROLE_SAVE]: (state: AdministrationRoleEditState, action: FailRoleExecute): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingSaveRole: false
    };
  },
  [ACTION.REQUEST_LOAD_ROLE]: (state: AdministrationRoleEditState, action: RequestLoadRole): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingLoadRole: true
    };
  },
  [ACTION.RECEIVE_LOAD_ROLE]: (state: AdministrationRoleEditState, action: ReceiveLoadRole): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingLoadRole: false,
      data: action.data
    };
  },
  [ACTION.FAIL_LOAD_ROLE]: (state: AdministrationRoleEditState, action: FailLoadRole): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingLoadRole: false
    };
  },
  [ACTION.REQUEST_LOAD_ROLE_ACCESS]: (state: AdministrationRoleEditState, action: RequestLoadRoleAccess): AdministrationRoleEditState => {
    return state;
  },
  [ACTION.RECEIVE_LOAD_ROLE_ACCESS]: (state: AdministrationRoleEditState, action: ReceiveLoadRoleAccess): AdministrationRoleEditState => {
    return {
      ...state,
      accessPerson: action.accessPerson
    };
  },
  [ACTION.FAIL_LOAD_ROLE_ACCESS]: (state: AdministrationRoleEditState, action: FailLoadRoleAccess): AdministrationRoleEditState => {
    return state;
  },
  [ACTION.CLEAR_ROLE_DATA]: (state: AdministrationRoleEditState, action: ClearRoleData): AdministrationRoleEditState => {
    return {
      ...state,
      ...INITIAL_ADMINISTRATION_ROLE_EDIT_STATE
    };
  },
  [ACTION.PROCESS_ROLE_FAILED]: (state: AdministrationRoleEditState, action: ProcessRoleFailed): AdministrationRoleEditState => {
    return {
      ...state,
      validation: action.errors,
      fetchingLoadRole: false
    };
  },
  [ACTION.REQUEST_ROLE_DELETE]: (state: AdministrationRoleEditState, action: RequestRoleDelete): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingLoadRole: true,
      shouldDisplayModal: false,
      ...INITIAL_SIMPLEFORM_STATE
    };
  },
  [ACTION.REQUEST_EXTRA_INFO]: (state: AdministrationRoleEditState, action: RequestExtraInfo): AdministrationRoleEditState => {
    return {
      ...state,
      extraInfoCodes: {
        fetching: true,
        values: []
      }
    };
  },

  [ACTION.RECEIVE_EXTRA_INFO]: (state: AdministrationRoleEditState, action: ReceiveExtraInfo): AdministrationRoleEditState => {
    return {
      ...state,
      extraInfoCodes: {
        fetching: false,
        values: action.values
      }
    };
  },

  [ACTION.FAIL_EXTRA_INFO]: (state: AdministrationRoleEditState, action: FailExtraInfo): AdministrationRoleEditState => {
    return {
      ...state,
      extraInfoCodes: {
        fetching: false,
        values: []
      }
    };
  },

  [ACTION.REQUEST_PERSON_OPTIONS]: (state: AdministrationRoleEditState, action: RequestPersonOptions): AdministrationRoleEditState => {
    return {
      ...state,
      personOptionsCodes: {
        fetching: true,
        values: []
      }
    };
  },

  [ACTION.RECEIVE_PERSON_OPTIONS]: (state: AdministrationRoleEditState, action: ReceivePersonOptions): AdministrationRoleEditState => {
    return {
      ...state,
      personOptionsCodes: {
        fetching: false,
        values: action.values
      }
    };
  },

  [ACTION.FAIL_PERSON_OPTIONS]: (state: AdministrationRoleEditState, action: FailPersonOptions): AdministrationRoleEditState => {
    return {
      ...state,
      personOptionsCodes: {
        fetching: false,
        values: []
      }
    };
  },

  [ACTION.CLEAR_VALIDATION]: (state: AdministrationRoleEditState, action: ClearValidation): AdministrationRoleEditState => {
    return {
      ...state,
      validation: clearValidation(state.validation, action.formName, action.parameters)
    };
  },

  [ACTION.UPDATE_ACCESS_DATA]: (state: AdministrationRoleEditState, action: UpdateAccessData): AdministrationRoleEditState => {

    const accessData = state.accessData || {};
    const accessItem = accessData[action.key] || {} as AccessItem;

    return {
      ...state,
      accessData: {
        ...accessData,
        [action.key]: {
          ...accessItem,
          ...action.accessItem
        }
      }
    };
  },

  [ACTION.REQUEST_DEFAULT_ROLE]: (state: AdministrationRoleEditState, action: RequestDefaultRole): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingDefaultRole: true
    };
  },

  [ACTION.RECEIVE_DEFAULT_ROLE]: (state: AdministrationRoleEditState, action: ReceiveDefaultRole): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingDefaultRole: false,
      currentDefaultRole: action.defaultRole,
      markedAsDefaultRole: action.markedAsDefaultRole
    };
  },

  [ACTION.FAIL_DEFAULT_ROLE]: (state: AdministrationRoleEditState, action: FailDefaultRole): AdministrationRoleEditState => {
    return {
      ...state,
      fetchingDefaultRole: false
    };
  },

  [ACTION.REQUEST_SET_DEFAULT_ROLE]: (state: AdministrationRoleEditState, action: RequestSetDefaultRole): AdministrationRoleEditState => {
    return {
      ...state,
      isSettingDefaultRole: true
    };
  },

  [ACTION.RECEIVE_SET_DEFAULT_ROLE]: (state: AdministrationRoleEditState, action: ReceiveSetDefaultRole): AdministrationRoleEditState => {
    return {
      ...state,
      isSettingDefaultRole: false
    };
  },

  [ACTION.FAIL_SET_DEFAULT_ROLE]: (state: AdministrationRoleEditState, action: FailSetDefaultRole): AdministrationRoleEditState => {
    return {
      ...state,
      isSettingDefaultRole: false
    };
  },

  [ACTION.CHANGE_DEFAULT_ROLE_MARK]: (state: AdministrationRoleEditState, action: ChangeDefaultRoleMark): AdministrationRoleEditState => {
    return {
      ...state,
      markedAsDefaultRole: action.mark
    };
  }
};

export const stateReducer: Reducer<AdministrationRoleEditState> =
  (state: AdministrationRoleEditState = INITIAL_ADMINISTRATION_ROLE_EDIT_STATE, action: any) => {
    const r = reducers[action.type];
    return (r && r(state, action)) || simpleFormReducer(STATE.administrationRoleEdit)(state, action);
  };

export const reducer = withOptionsReducer(STATE.administrationRoleEdit, stateReducer);
